import { EMessageStatus } from '@/store/messageStore';
import { FC } from 'react';
import { SpinComp, FailComp, ReadTickComp } from '@/Icons';

interface IBubbleStatus {
  status: EMessageStatus;
  className?: string;
  onClick?: (status: EMessageStatus) => void;
}

const BubbleStatus: FC<IBubbleStatus> = ({ status, className, onClick }) => {
  if (status === EMessageStatus.fail) {
    return (
      <FailComp
        className={`w-48 md:w-24 ${className}`}
        onClick={() => onClick?.(EMessageStatus.fail)}
      />
    );
  }

  if (status === EMessageStatus.pending) {
    return (
      <SpinComp
        onClick={() => onClick?.(EMessageStatus.pending)}
        className={`w-48 md:w-24 ${className}`}
      />
    );
  }
  if (status === EMessageStatus.success) {
    return <></>;
  }
};
export default BubbleStatus;

/**
 * handle message had read
 */
export const BubbleReadStatus: FC<{ isRead: boolean; className?: string }> = ({
  isRead,
  className,
}) => {
  if (isRead) {
    return <ReadTickComp className={`flex-48 md:flex-16 ${className}`} />;
  }

  return <></>;
};
